import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';

export const EntrySource = styled.div`
  background: ${colors.grey1};
  border: ${spacing.single} solid ${colors.grey5};
  border-radius: ${spacing.half};
`;

export const SourceSetup = styled.div`
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const EntrySourceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
`;
